export const Tv = () => import("./Tv.vue");
export const Menu = () => import("./Menu.vue");
export const Dashboard = () => import("./Dashboard.vue");
export const MenuChildren = () => import("./MenuChildren.vue");
export const OfficeDashboard = () => import("./OfficeDashboard.vue");
export const PensionCalculators = () => import("./PensionCalculators.vue");
